import { TrendingUp } from 'lucide-react';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function Header({ activeMetric, setActiveMetric }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { id: 'companyOverview', label: 'Company Overview' },
    { id: 'financialMetrics', label: 'Financial Metrics' },
    { id: 'valuationAnalysis', label: 'Valuation Analysis' },
    { id: 'aiInsights', label: 'AI Insights' }
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <TrendingUp className="h-8 w-8 text-blue-600" />
          <h1 className="text-2xl font-bold text-gray-900">ViewValue.io</h1>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-4">
          {menuItems.map(({ id, label }) => (
            <button
              key={id}
              onClick={() => setActiveMetric(id)}
              className={`px-4 py-2 rounded-lg transition-colors ${
                activeMetric === id ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:text-blue-500'
              }`}
            >
              {label}
            </button>
          ))}
        </nav>

        {/* Mobile Hamburger Menu */}
        <div className="md:hidden flex items-center">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 focus:outline-none">
            {isMenuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown with Buttons */}
      {isMenuOpen && (
        <nav className="md:hidden bg-gray-100 transition-all duration-300 p-4 space-y-2 border-t">
          {menuItems.map(({ id, label }) => (
            <button
              key={id}
              onClick={() => {
                setActiveMetric(id);
                setIsMenuOpen(false);
              }}
              className={`block w-full text-center py-2 rounded-lg font-medium transition ${
                activeMetric === id ? 'bg-blue-200 text-blue-700' : 'text-gray-700 hover:bg-gray-200'
              }`}
            >
              {label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
}
